import { Typography } from '@breetometer/components';
import { CryptoDestinationIcon, InfoIcon } from 'BreetAssets';
import { Tab } from 'BreetComponents';
import { FXCONVERSION, FXRATE } from 'BreetHelpers';
import { useCurrentFxRate, useTab } from 'BreetHooks';

import FormBuyCrypto from './Form.BuyCrypto';
import FormSellCrypto from './Form.SellCrypto';

export const Form = () => {
	const tabProps = useTab<'Sell' | 'Buy'>('Sell');

	const currentFxRate = useCurrentFxRate({
		fxRate: tabProps.activeTab === 'Sell' ? FXRATE.DEFAULT : FXRATE.BUY,
		conversionType: tabProps.activeTab === 'Buy' ? FXCONVERSION.FIATToUSD : FXCONVERSION.SELLUSD,
	});

	return (
		<form className='payment-request-form'>
			<div className='rate-section'>
				<div className='rate-amount-container bg-primary-400 border-dark-navy'>
					<div className='rate-amount bg-primary-400'>
						<div className='left'>
							<CryptoDestinationIcon />
							<Typography className='color-tertiary-400'>Rate:</Typography>
						</div>
						<div className='right'>
							<Typography className='color-primary-50'>
								<span>
									<span className='currency'>{currentFxRate.symbol.from}</span>
									{currentFxRate.rate}/<span className='currency dollar'>{currentFxRate.symbol.to}</span>
								</span>
							</Typography>
						</div>
					</div>
				</div>

				<div className='rate-tab-selection hidden'>
					<Tab.Header
						{...tabProps}
						type='block'
						tabs={['Sell', 'Buy']}
					/>
				</div>
			</div>

			<div className='rate-section-info bg-primary-400 border-dark-navy'>
				<div className='content bg-primary-400'>
					<InfoIcon
						variant='wallet'
						className='svg-light'
					/>
					<Typography className='color-primary-100'>The same single rate applies across all assets.</Typography>
				</div>
			</div>

			<Tab.Body
				isActive={tabProps.activeTab === 'Sell'}
				removeDOM
			>
				<FormSellCrypto />
			</Tab.Body>

			<Tab.Body
				isActive={tabProps.activeTab === 'Buy'}
				removeDOM
			>
				<FormBuyCrypto />
			</Tab.Body>
		</form>
	);
};
